export class Deployment {
    public applicationName : String;
    public deploymentId : String;
    public status : String;
    public errorInformation : String;
    public createTime : Date;
    public completeTime : Date;
}